import React from 'react';
import styles from './ProductAdvisory.module.scss';
import { Col, Container, Row } from 'reactstrap';
import { useNavigate } from 'react-router-dom';

const personalizedData = [
    { id: '1', value: 2, label: 'Product Title Optimization' },
    { id: '2', value: 2, label: 'Description Enhancement' },
    { id: '3', value: 2, label: 'Category Correction' },
    { id: '4', value: 2, label: 'Video Check' },
    { id: '5', value: 2, label: 'Image Quality Check' },
];

const marketingData = [
    { heading: 'Trending Products', firstItem: 'Fitness trackers +20% sales', secondItem: 'Smart watches +20% sales' },
    { heading: 'Seasonal Products', firstItem: 'Portable fans demand in June', secondItem: 'Sunglasses' },
];

const competitorData = [
    { value: 30, label: 'Competitive products' },
    { value: 10, label: 'Expensive products' },
    { value: 5, label: 'Low-priced products' },
];

const pricingData = [
    { heading: 'Dynamic Pricing', guideNote: 'Adjust prices based on market conditions', content: 'Reduce price by 10% to match top-selling products.' },
    { heading: 'Discount Strategies', guideNote: 'Effective discount and promotional pricing tips', content: 'Offer a 15% discount during the holiday season.' },
];

const forecastingData = [
    { heading: 'Short-term', guideNote: 'Predictions for the next few weeks', content: 'Expected sales for next month: 200 units' },
    { heading: 'Long-term', guideNote: 'Predictions for the next few months', content: 'Expected sales for next quarter: 600 units' },
];

const inventoryData = [
    { heading: 'Re-order alert', content: '20 units left in stock' },
    { heading: 'Inventory Turnover Rate', content: '1.5 months' },
    { heading: 'Safety Stock Recommendations', content: 'Safety stock: 50 units' },
];

const ProductAdvisory = () => {
    const navigate = useNavigate();

    const handleTabClick = (labelId) => {
        navigate('/compliance/productadvisory/recommendations', { state: { selectedTab: labelId } });
    };

    return (
        <div className={styles.mainContainer}>
            <h4 className={styles.mainHeading}>Product Advisory</h4>

            <Container fluid className={styles.headerText}>
                <p>
                    Product Advisor is designed to empower you with personalized recommendations, market
                    trends, and strategic advice to help you optimize your product listings, stay ahead of
                    the competition, and maximize your sales. Explore the detailed sections below to discover
                    how you can enhance your product performance and grow your business with ease.
                </p>
            </Container>

            <Row className={`${styles.contentRow} row-cols-1 row-cols-lg-2`}>
                <Col className={styles.contentColumn}>
                    <h4 className={styles.sectionHeading}>Personalized Recommendations</h4>
                    <Row className={styles.contentDataRow}>
                        {personalizedData.map((item, index) => (
                            <Col lg={6} key={index}>
                                <div
                                    className={styles.personalizedContainer}
                                    onClick={() => handleTabClick(item.id)}
                                >
                                    <p className={styles.personalizedValue}>{item.value}</p>
                                    <p>{item.label}</p>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Col>
                <Col className={styles.contentColumn}>
                    <h4 className={styles.sectionHeading}>Market Trends</h4>
                    <Row className={styles.contentDataRow}>
                        {marketingData.map((item, index) => (
                            <Col lg={6} key={index}>
                                <div className={styles.advisoryContainer}>
                                    <h5 className={styles.sectionHeading}>{item.heading}</h5>
                                    <p className={styles.trendContent}>{item.firstItem}</p>
                                    <p className={styles.trendContent}>{item.secondItem}</p>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Col>
            </Row>

            <Row className={`${styles.contentRow} row-cols-1 row-cols-lg-2`}>
                <Col className={styles.contentColumn}>
                    <h4 className={styles.sectionHeading}>Competitor Analysis</h4>
                    <Row className={styles.contentDataRow}>
                        <h5 className={styles.competitorSectionHeading}>Pricing Comparison</h5>
                        {competitorData.map((item, index) => (
                            <div key={index} className={styles.advisoryContainer}>
                                <p>{item.label}: <span className={styles.personalizedValue}>{item.value}</span></p>
                            </div>
                        ))}
                        <h5 className={styles.competitorSectionSecondHeading}>Feature Comparison</h5>
                        <p>Competitors offer free shipping, try this feature</p>
                    </Row>
                </Col>
                <Col className={styles.contentColumn}>
                    <h4 className={styles.sectionHeading}>Pricing Suggestions</h4>
                    <Row className={styles.contentDataRow}>
                        {pricingData.map((item, index) => (
                            <Col lg={12} key={index}>
                                <div className={styles.pricingContainer}>
                                    <h5>{item.heading}</h5>
                                    <p className={styles.pricingHeadingGuide}>({item.guideNote})</p>
                                </div>
                                <p className={styles.pricingContent}>{item.content}</p>
                            </Col>
                        ))}
                    </Row>
                </Col>
            </Row>

            <Row className={`${styles.contentRow} row-cols-1 row-cols-lg-2`}>
                <Col className={styles.contentColumn}>
                    <h4 className={styles.sectionHeading}>Sales Forecasting</h4>
                    <Row className={styles.contentDataRow}>
                        {forecastingData.map((item, index) => (
                            <Col lg={12} key={index}>
                                <div className={styles.pricingContainer}>
                                    <h5>{item.heading}</h5>
                                    <p className={styles.pricingHeadingGuide}>({item.guideNote})</p>
                                </div>
                                <p className={styles.pricingContent}>{item.content}</p>
                            </Col>
                        ))}
                    </Row>
                </Col>
                <Col className={styles.contentColumn}>
                    <h4 className={styles.sectionHeading}>Inventory Optimization</h4>
                    <Row className={styles.contentDataRow}>
                        {inventoryData.map((item, index) => (
                            <Col lg={6} key={index}>
                                <div className={styles.advisoryContainer}>
                                    <h5 className={styles.sectionHeading}>{item.heading}</h5>
                                    <p>{item.content}</p>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Col>
            </Row>
        </div>
    )
}

export default ProductAdvisory;